var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _setup.unreadCount > 0 &&
      (_setup.pathMessage === _setup.path || !_setup.messageList.page) &&
      !_setup.hideMessage
        ? _c(
            "v-system-bar",
            {
              class: [
                "grey--text text--darken-4",
                _setup.colors[_setup.messageList.type],
              ],
              attrs: { window: "", app: "", height: "50" },
            },
            [
              _c("v-icon", [_vm._v(_vm._s(_setup.messageList.icon))]),
              _c("span", {
                attrs: { id: "alert-system-bar" },
                domProps: { innerHTML: _vm._s(_setup.messageList.message) },
              }),
              _c("v-spacer"),
              _c("v-checkbox", {
                staticClass: "hide-message",
                attrs: {
                  color: "primary",
                  label: "Não exibir essa mensagem novamente",
                },
                model: {
                  value: _setup.removeMessage,
                  callback: function ($$v) {
                    _setup.removeMessage = $$v
                  },
                  expression: "removeMessage",
                },
              }),
              _c(
                "v-tooltip",
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _c(
                              "ButtonsFab",
                              _vm._g(
                                _vm._b(
                                  {
                                    attrs: {
                                      "x-small": "",
                                      icon: "mdi-window-close",
                                      color: "white",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        _setup.hideMessage = true
                                      },
                                    },
                                  },
                                  "ButtonsFab",
                                  attrs,
                                  false
                                ),
                                on
                              )
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    892328816
                  ),
                },
                [_c("span", [_vm._v("Fechar mensagem")])]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }